import { useForm, useWatch } from "react-hook-form";
import { TextInput } from "../../form";
import { useDebounced } from "../../hooks";
import { useTranslation } from "../../localization";
import { useDataTableContext } from "./context";

export function DataTableSearch() {
	/** Context */
	const { table } = useDataTableContext();

	/** Hooks */
	const methods = useForm<{ search: string }>({
		defaultValues: {
			search: table.state.globalFilter,
		},
	});
	const searchValue = useWatch({ control: methods.control, name: "search" });

	/** Hooks */
	const { t } = useTranslation();
	useDebounced({
		value: searchValue,
		fn: table.setGlobalFilter,
		timeout: 150,
	});

	/** Render */
	return (
		<div className="flex-1 max-w-[400px]">
			<TextInput
				label={undefined}
				className="input"
				placeholder={t("placeholders.search")}
				control={methods.control}
				name="search"
				type="search"
				isRequired={false}
				data-cy="data-table-search-input"
			/>
		</div>
	);
}
